export const FORM_NAME = 'forgotPassword'

export const LOGIN_PROPERTY = 'email'

export const FORGOT_PASSWORD_SUCCESS = 'A password reset message was sent to your email address. If you do not receive a password reset message within a few moments, please check your spam folder.'

export const THANK_YOU_TITLE = 'Thank You'

export const FORGOT_PASSWORD_TITLE = 'Forgot Password'
